document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        setTimeout(function() {
            window.anims();
            window.carousels();
            cover.remove();
            
            document.getElementById('map') ? window.contactMap() : false;
        }, 250);  
    };
    
    window.addEventListener('load', init);

}, false);